<template>
  <div class="lgprConfirm">
    <div class="confirmMessage">
      <h3>Your LGPR will start after your confirmation</h3>
    </div>
    <el-button
      type="primary"
      @click="confirm"
    >
      Confirm
    </el-button>
  </div>
</template>

<script>
import api from '@/api';

export default {
  methods: {
    async confirm() {
      try {
        await api.launchCurrentLGPR();
        this.$message.success('Your LGPR has been launched.');
        this.$emit('confirm', true);
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.lgprConfirm {
  padding: 100px 0;

  .confirmMessage {
    margin: 50px 0;
  }
}
</style>
